module.exports = __webpack_public_path__ + "static/media/Pericles.a9e2481e.jpg";